<template>
    <div>
        <div class="card border-0 m-b-10">
            <div class="card-body">
                <div class="card-text">
                    <div v-for="(item,index) in filteredList" :key="index" class="row m-b-10">
                        <div v-for="(listItem,listIndex) in item" :class="'col-xl-'+colReturner(item.length)+' col-md-'+colReturner(item.length)" :key="listIndex">
                            <b-carousel :key="listIndex"
                                    v-model="listItem.slide"
                                    :interval="0"
                                    controls
                                    indicators
                                    background="#ababab"
                                    img-width="1024"
                                    img-height="480"
                                    style="text-shadow: 1px 1px 2px #333;"
                                    @sliding-start="onSlideStart"
                                    @sliding-end="onSlideEnd">
                                <b-carousel-slide v-for="(linkItem,linkIndex) in listItem.links" :key="linkIndex"
                                                  :text="listItem[languageGet]"
                                                  :img-src="linkItem"
                                ></b-carousel-slide>
                            </b-carousel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';

    export default {
        computed: mapGetters(["languageGet", "galleryListGet"]),
        data() {
            return {
                sliding: null,
                filteredList: [],
            }
        },
        mounted() {
            this.filteredList = this.colSplit(this.galleryListGet, 7);
        },
        methods: {
            onSlideStart() {
                this.sliding = true
            },
            onSlideEnd() {
                this.sliding = false
            },
            colSplit(arr, c) {
                let res = new Array(c);
                for (let i = 0; i < c; ++i) {
                    res[i] = [];
                }
                for (let i = 0; i < arr.length; ++i) {
                    res[i % c].push(arr[i]);
                }
                return res;
            },
            colReturner(num){
                return 12 / num;
            }
        }
    }
</script>